export enum ValidatorsEnum {
    REQUIRED = 'REQUIRED',
    MIN = 'MIN',
    MAX = 'MAX',
    MIN_LENGTH = 'MIN_LENGTH',
    MAX_LENGTH = 'MAX_LENGTH'
}
